export const Role = [
    { 'id': 2, 'role': 'Admin' },
    { 'id': 3, 'role': 'Developer' },
    { 'id': 4, 'role': 'Tester' },
    { 'id': 5, 'role': 'Viewer' },
    { 'id': 6, 'role': 'SuperAdmin'}
]